import { forwardRef } from "react";
import styles from "./styles.module.css";
import BackIcon from "images/svg/back.svg";
import { KEYPAD_BUTTONS } from "const";

const KeyPadVertical = forwardRef(({ onInput }, ref) => {
  const keys = [
    { label: "1", value: KEYPAD_BUTTONS.ONE, style: { borderTopLeftRadius: "20px" } },
    { label: "2", value: KEYPAD_BUTTONS.TWO },
    { label: "3", value: KEYPAD_BUTTONS.THREE, style: { borderTopRightRadius: "20px" } },
    { label: "4", value: KEYPAD_BUTTONS.FOUR },
    { label: "5", value: KEYPAD_BUTTONS.FIVE },
    { label: "6", value: KEYPAD_BUTTONS.SIX },
    { label: "7", value: KEYPAD_BUTTONS.SEVEN },
    { label: "8", value: KEYPAD_BUTTONS.EIGHT },
    { label: "9", value: KEYPAD_BUTTONS.NINE },
    { label: ".", value: KEYPAD_BUTTONS.DOT, style: { borderBottomLeftRadius: "20px" } },
    { label: "0", value: KEYPAD_BUTTONS.ZERO },
    {
      label: <img src={BackIcon} alt="Back" />,
      value: KEYPAD_BUTTONS.DELETE,
      style: { borderBottomRightRadius: "20px", backgroundColor: "rgba(226, 225, 228, 1)" },
    },
  ];

  return (
    <div className={styles.keypad} tabIndex={-1} ref={ref} style={{ outline: "none" }}>
      {keys.map((key, index) => (
        <button
          key={index}
          className={styles.keyBtn}
          style={key.style}
          onClick={() => onInput(key.value)}
          tabIndex={-1}
        >
          {key.label}
        </button>
      ))}
    </div>
  );
});

export default KeyPadVertical;
